import {React, useEffect, useState} from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import BannerWithContent from '../../UI/Banner/banner-with-content/BannerWithContent';
import MedicalTourismBannerImage from '../../assets/Images/Homepage/Desktop_mediBanner.jpg';
import GlobalHealthCarePackage from './components/globalHealthCarePackage';
import WhychooseBanner from '../../UI/Banner/medicalTourismBanners/whychooseBanner';
import MembershipCard from '../../UI/Global-Component/MembershipCard';
import Faq from '../../UI/Global-Component/Faq';
import '../Page-style/medicaltourism-page.scss';
import CommonModal from '../../UI/UIComponent/Modal/CommonModal';
import ConsultationBooking from '../../FeatureComponent/QuickBooking/consultationBooking';
import OtpModal from '../../UI/UIComponent/Modal/OtpModal';
import faqData from '../../StaticData/medicaltourismFaq.json';

export default function MedicalTourism() {
  const [patientPayload,setpatientPayload] = useState({});
    const [encodedData, setEncodeddata] = useState();
    const handleCallback = (childData) =>{
      setpatientPayload({...childData});
      setEncodeddata(childData.encodedData)
    }
    const handleClickOnCard = () =>{
      let modalRef = document.getElementById('consultation-modal');
      modalRef.classList.add('show');
    }
  return (
    <>
        <CommonModal></CommonModal>
        <ConsultationBooking parentCallback={handleCallback} data-pageid="medicalTourismPage"></ConsultationBooking>
        <OtpModal patientInfoPayload = {patientPayload} patientEncodedData = {encodedData}></OtpModal>
        <Header pageId={'3'}></Header>
        <section className='medical-tourism-page'>
            <BannerWithContent imagepath={MedicalTourismBannerImage}></BannerWithContent>
            <GlobalHealthCarePackage onKnowMoreClick={handleClickOnCard}></GlobalHealthCarePackage>
            <WhychooseBanner></WhychooseBanner>
            <Faq faqData={faqData.faqData}></Faq>
            <MembershipCard></MembershipCard>
            <Footer></Footer>
        </section>
        
    </>
  )
}






 
